import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
export class LoginComponent {
    constructor(fb, route, router, authService, utils, translate) {
        this.fb = fb;
        this.route = route;
        this.router = router;
        this.authService = authService;
        this.utils = utils;
        this.translate = translate;
        let _self = this;
        _self.lang = _self.utils.getLanguage();
        _self.translate.use(_self.lang);
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/home';
            this.form = this.fb.group({
                username: ['', Validators.email],
                password: ['', Validators.required]
            });
            if (this.authService.getToken()) {
                yield this.router.navigate([this.returnUrl]);
            }
        });
    }
    onSubmit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            _self.loginError = "";
            _self.formSubmitAttempt = false;
            if (_self.form.valid) {
                const username = _self.form.get('username').value;
                const password = _self.form.get('password').value;
                _self.authService.login(username, password).then(() => {
                    _self.loginError = "";
                    _self.router.navigate(['home']);
                }).catch((err) => {
                    return _self.utils.getError(err);
                }).then((translatedError) => {
                    if (translatedError) {
                        _self.loginError = translatedError;
                    }
                }).finally(() => {
                    _self.utils.hideShortLoader();
                });
            }
            else {
                _self.formSubmitAttempt = true;
            }
        });
    }
    changeLanguage(event) {
        this.utils.setLanguage(this.lang);
    }
}
